import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const templateEditorPlaceCursorStyles: IStyles = {
    placeCursor: {
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 10000,
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 28,
        height: 28,
        borderRadius: 8,
        background: color.bgWhitePrimary,
        border: `1px solid ${color.blue}`,
        boxShadow: `0 3px 12px ${color.bgAlphaDark50}`,
        color: color.blue,
        willChange: 'transform',
    },
    placeCursorMedia: {
        width: 40,
        height: 40,
        borderRadius: 10,
    },
    placeCursorHidden: {
        opacity: 0,
    },
    thumb: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: 9,
        display: 'block',
    },
}

addStyles(templateEditorPlaceCursorStyles)
export default templateEditorPlaceCursorStyles
